import React from "react";
import { FormattedMessage } from "react-intl";
import { CREDITS } from "../../../../constants";
import CoinUsage from "../CoinUsage/CoinUsage";

export default function ActivityItem({ item }) {
  return (
    <tr>
      <td style={{ width: "200px" }}>
        {Intl.DateTimeFormat("us-US", {
          dateStyle: "short",
          timeStyle: "medium",
        }).format(new Date(item.infos.updatedAt))}
      </td>
      <td>{item.email}</td>
      <td>
        {
          <FormattedMessage
            id={"organization.filters." + item.infos.usageType}
          />
        }
      </td>
      <td>{item.target}</td>
      <td className="spent-credit">
        {CREDITS.map(
          (creditType) =>
            item.credits[creditType] &&
            !!item.credits[creditType].amount && (
              <CoinUsage
                creditUsage={
                  (item.isDecreased ? "-" : "+") +
                  item.credits[creditType].amount
                }
                type={creditType}
              />
            )
        )}
      </td>
    </tr>
  );
}
